"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const SameAuth_1 = __importDefault(require("./SameAuth"));
const UserStore_1 = require("./lightState/UserStore");
const LoginScreen_1 = __importDefault(require("./LoginScreen"));
const react_hot_toast_1 = __importDefault(require("react-hot-toast"));
function default_1({ children }) {
    const [isAuthenting, setIsAuthenting] = react_1.useState(false);
    const isAuthened = UserStore_1.useStore((state) => state.isAuthened);
    react_1.useEffect(() => {
        checkAuth();
    }, []);
    const checkAuth = () => __awaiter(this, void 0, void 0, function* () {
        yield SameAuth_1.default.authenUrlCallback(() => {
            setIsAuthenting(true);
            react_hot_toast_1.default.loading("Login you in...");
        }, (user) => {
            setTimeout(() => {
                react_hot_toast_1.default.success(`Welcome back, ${user.name}`);
            }, 1000);
        });
        setIsAuthenting(false);
    });
    if (!isAuthened) {
        return react_1.default.createElement(LoginScreen_1.default, { isAuthenting: isAuthenting });
    }
    return react_1.default.createElement(react_1.default.Fragment, null, children);
}
exports.default = default_1;
//# sourceMappingURL=AuthorizedAppWrap.js.map